import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DataTable from "react-data-table-component"; // Assuming DataTable is installed and configured
import { deleteStaff, fetchStaff } from "../../../slices/admin/staffSlice"; // Import your action to fetch staff
import { Link } from "react-router-dom";
import { Delete, Pen } from "lucide-react";
import Swal from "sweetalert2";
import { customTableStyles } from "../../../utils/tableStylings";

const AdminStaffList = () => {
    const dispatch = useDispatch();
    const { staff, loading } = useSelector((state) => state.adminStaff); // Assuming state is set in Redux

    const [search, setSearch] = useState("");

    // Dispatch fetchStaff action when the component mounts
    useEffect(() => {
        dispatch(fetchStaff()); // Dispatch action to fetch staff
    }, [dispatch]);


    
    const handleDelete = (id) => {
        Swal.fire({
            title: '<strong>Are you sure?</strong>',
            html: `<p>This action will <b>permanently delete</b> this Staff Member.</p>`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel',
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteStaff(id));
                Swal.fire({
                    icon: 'success',
                    title: 'Deleted!',
                    text: 'The Staff Member has been deleted.',
                    toast: true,          // Enable toast style
                    position: 'top-end',  // Position at the top-right corner
                    showConfirmButton: false,  // Hide the confirm button
                    timer: 3000,          // Set the timer to auto-close after 3 seconds
                    timerProgressBar: true,  // Show the progress bar for the timer
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer);
                        toast.addEventListener('mouseleave', Swal.resumeTimer);
                    }
                });
                
            }
        });
    };
    // Columns configuration for DataTable
    const columns = [
        {
            name: "#", // Index Column
            selector: (row, index) => index + 1, // Adds 1 to index to start from 1
            sortable: false, // Index is not sortable
        },
        {
            name: "Image",
            cell: (row) => (
                <img
                    src={row.image || "default-image.jpg"} // Add a default image if no image is provided
                    alt={row.name}
                    style={{ width: "40px", height: "40px", borderRadius: "50%" }}
                />
            ),
            sortable: false,
        },
        {
            name: "Name",
            selector: (row) => row.name,
            sortable: true,
        },
        {
            name: "Email",
            selector: (row) => row.email,
            sortable: true,
        },
        {
            name: "Role",
            selector: (row) => row.AdminRole?.name, // Access the role name correctly
            sortable: true,
        },
        {
            name: "Actions", // Actions Column
            cell: (row) => (
                <div>
                    <Link
                        className="text-success btn-sm me-2"
                        to={'/admin/staff/edit'}
                        state={{staffData: row}}
                    >
                        <Pen/>
                    </Link>
                    <Link
                        className="text-danger btn-sm"
                        onClick={() => handleDelete(row.id)} // Add your delete function here
                    >
                        <Delete/>
                    </Link>
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true, // Allow buttons to be used in the table
        },
        
    ];

    // Optional: Filter staff based on search input
    const filteredStaff = staff.filter((staffMember) =>
        staffMember?.name?.toLowerCase().includes(search?.toLowerCase())
    );
    

    return (
        <div className="row">
            <div className="col-12">
                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="card-title">Staff List</h4>
                        <Link to={'/admin/staff/add'} className="btn btn-primary">Add New</Link>
                    </div>
                    <div className="card-body">
                        <input
                            type="text"
                            placeholder="Search Staff"
                            className="form-control mb-3"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                        <div className="table-responsive">
                            <DataTable
                                className="table-hover custom-table"
                                columns={columns}
                                data={filteredStaff} // Use filtered data
                                pagination
                                striped
                                progressPending={loading} 
                                customStyles={customTableStyles}// Show loading state when fetching data
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminStaffList;
